<template>
  <section class="d-flex flex-column h-full">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>

    <!-- <div class="tab_bar w-full">
      <div class="nav-content teal lighten-2 mdc-tab-bar top-tab-bar" role="tablist">
        <div class="mdc-tab-scroller">
          <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
            <ul class="tabs w-full mdc-tab-scroller__scroll-content">
              <li class="tab">
                <a
                  href="#tab1"
                  class="w-full d-block t-color-title tab mdc-tab mdc-tab--active"
                  role="tab"
                  tabindex="0"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">{{$t('1497')}}</span>
                  </span>
                  <span class="mdc-tab-indicator mdc-tab-indicator--active">
                    <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </a>
              </li>
              <li class="tab">
                <a
                  href="#tab2"
                  class="w-full d-block t-color-title tab mdc-tab"
                  role="tab"
                  tabindex="1"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">{{$t('1498')}}</span>
                  </span>
                  <span class="mdc-tab-indicator">
                    <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <!-- </div> -->
    <div class="flex-grow-1 scroll-y">
      <HelpDeskList></HelpDeskList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <!-- <div id="tab1" class="t-color-content1 pdt-16 pdb-32">
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >계정 관리</button>
            <button
              class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >로그인 또는 로그아웃</button>
          </div>
          <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스에 로그아웃</div>
          <div
            class="t-body3 t-color-content1 l-spacing42 font-r"
          >서비스를 사용 중인 기기에 따라 로그아웃하거나 계정을 삭제하거나 다른 조치를 취할 수 있습니다.</div>
          <div class="pdt-24">
            <button
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"
            >
              <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
            </button>
          </div>
        </div>
      </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-blue3 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >설정</button>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >설정 변경</button>
          </div>
          <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스 설정 변경하기</div>
          <div class="t-body3 t-color-content1 l-spacing42 font-r">
            전화 번호를 추가하거나 알림 수신 설정을 변경합니다.
            <a
              href="https://www.google.com/search?source"
            >https://www.google.com/search?source</a>
          </div>
        </div>
      </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >문제 해결</button>
            <button
              class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >동기화</button>
          </div>
          <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스 설정 변경하기</div>
          <div class="t-body3 t-color-content1 l-spacing42 font-r">
            안드로이드 앱이 자동으로 동기화되지 않으면 다음과 같은 문제가 발생할 수 있습니다. 각 단계를
            수행한 …
          </div>
          <div class="pdt-24">
            <button
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"
            >
              <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
            </button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div id="tab2" class="t-color-content1 pdt-16 pdb-32">
      <div class="pdl-16 pdr-16 pdb-16 mgb-16 listItems d-flex justify-content-between">
        <div class="t-body2 t-color-content1 font-m d-flex align-items-center">
          나의 문의
          <span
            class="queryCount bg-dark t-color-white t-caption t-center w-18 h-16 d-inline-block mgl-4"
          >22</span>
        </div>
        <div class="t-body2 t-color-warning font-m">1:1 문의하기</div>
      </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >계정 관리</button>
            <button
              class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >로그인 또는 로그아웃</button>
          </div>
          <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">온라인 강의는 꼭 구매해야 하나요?</div>
          <div
            class="t-body3 t-color-content1 l-spacing42 font-r"
          >서비스를 사용 중인 기기에 따라 로그아웃하거나 계정을 삭제하거나 다른 조치를 취할 수 있습니다.</div>
          <div class="pdt-24">
            <button
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 mgr-4 b-radius2 mgb-4 font-r"
            >
              <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
            </button>
          </div>
        </div>
      </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-blue3 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >설정</button>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >설정 변경</button>
          </div>
          <div
            class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m"
          >온라인 강의는 어떻게 수료할 수 있나요?</div>
          <div class="t-body3 t-color-content1 l-spacing42 font-r">
            전화 번호를 추가하거나 알림 수신 설정을 변경합니다.
            https://www.google.com/search?source
            <a
              href="https://www.google.com/search?source"
            >https://www.google.com/search?source</a>
          </div>
        </div>
      </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
          <div>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 mgr-4 b-radius2 l-spacing36 font-r"
            >문제 해결</button>
            <button
              class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
            >동기화</button>
          </div>
          <div
            class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m"
          >저는 안드로이드 기기 유저인데 앱에서 자동 동기화 오류가 발생하는 것 같아요</div>
          <div
            class="t-body3 t-color-content1 l-spacing42 font-r"
          >안드로이드 앱이 자동으로 동기화되지 않으면 다음과 같은 문제가 발생할 수 있습니다. 각 단계를 수행한 …</div>
          <div class="pdt-24">
            <button
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pd5-4 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r"
            >
              <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import HelpDeskList from "@/components/helpDesk/List";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
    };
  },
  components: {
    TopAppBar,
    HelpDeskList,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  mounted() {
    this.setTopAppBarBack(this.$t("1497"));
  },
};

// Components/Mixin/Extend/API define
// import TopAppBar from "@/components/TopAppBar.vue";
// import { topAppBarMixin } from "@/mixins/topAppBar.js";
// import HelpDeskList from '@/components/helpDesk/List'
// import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

// export default {
//   name: "learn",

//   data() {
//     return {
//       leftBtnMethod: () => {
//         this.$router.go(-1);
//       },
//       tabBar: null,
//     };
//   },
//   components: {
//     TopAppBar,
//HelpDeskList,
// Faq: () => import("@/components/helpDesk/Faq.vue"),
// Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
//   },

//   mixins: [topAppBarMixin],

//   watch: {
//     $route(to, from) {},
//   },

//   mounted() {
//     $(document).ready(function () {
//       $(".tabs").tabs();
//     });
//     this.tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
//     this.setTabActive();
//     this.setTopAppBarBackSearch(this.$t("1496"));
//   },

//   methods: {
//     setTabActive() {
//       let status = this.$route.query.status;
//       if (status === "FAQ") {
//         this.tabBar.activateTab(0);
//       } else if (status == "INQUERY") {
//         this.tabBar.activateTab(1);
//       } else {
//         this.tabBar.activateTab(0);
//       }
//     },
//   },
// };
//
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}
.b-radius2 {
  border-radius: 2px;
}
.l-spacing36 {
  letter-spacing: -0.36px;
}
.font-16 {
  font-size: 16px;
}
.bg-blue3 {
  background-color: #80aed4;
}
.queryCount {
  border-radius: 50%;
  line-height: 1.7;
}
.font-11 {
  font-size: 11px !important;
}
#tab1,
#tab2 {
  margin-top: 112px;
}
</style>